import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => (
  <div className="text-center py-24">
    <h1 className="text-4xl font-bold mb-4">Page not found</h1>
    <p className="text-gray-600 mb-6">The page you are looking for does not exist.</p>
    <Link to="/" className="text-indigo-600 hover:text-indigo-700 font-medium">
      Go home
    </Link>
  </div>
);

export default NotFound;
